import React from "react";
import img from '../../../assets/images/32.jpg'
import Icon from '../../Icon';

const BannerHome = () => {

    return (
        <div className="banner reveal">
            <div className="banner-item banner-media">
                <div className="banner-animated reveal_4"></div>
                <div className="banner-img reveal_1"> <img src={img} alt="" /> </div>
                <div className="banner-play reveal_4"><div className="banner-playing"><Icon name='play' /></div></div>
            </div>
            <div className="banner-item banner-definition">
                <h1 className="title banner-title reveal_2">Bienvenue sur le site de SANSOFTIC</h1>
                <p className="banner-para reveal_3">
                SANSOFTIC est une société numériques qui offre une gamme de services et de solutions aux entreprises, aux organisations et aux particuliers en fonction de leurs besoins.
                </p>
            </div>
        </div>
    )
}

export default BannerHome;